export function PercentageDiscount(price, campaignPrice) {
  if (price <= 0 || campaignPrice <= 0) {
    return '';
  }
  const percentagePrecise = 100 * (1 - campaignPrice / price);
  const percentageTwoDecimals = Math.round(percentagePrecise * 100) / 100;
  var percentage = Math.floor(percentageTwoDecimals);
  if (percentage <= 0) {
    return '';
  }

  return '-' + percentage + '%';
}
